import api from '@/api'

export default function plugin (Vue) {
  // api 配置
  Vue.$api = Vue.prototype.$api = api
}



// WEBPACK FOOTER //
// ./src/utils/globalConfig.js